import { useCallback } from "react";
import { useMutation, useQuery } from "convex/react";

import { api } from "@convex/_generated/api";

export function useIntegrations() {
  const calendlyIntegration = useQuery(api.integrations.getByProvider, {
    provider: "calendly",
  });
  const connectTelegram = useMutation(api.integrations.connectTelegram);
  const disconnectComposioIntegration = useMutation(
    api.integrations.disconnectComposioIntegration,
  );
  const disconnectGoogleSheets = useMutation(api.integrations.disconnectGoogleSheets);
  const disconnectTelegram = useMutation(api.integrations.disconnectTelegram);
  const facebookIntegration = useQuery(api.integrations.getByProvider, {
    provider: "facebook",
  });
  const gmailIntegration = useQuery(api.integrations.getByProvider, {
    provider: "gmail",
  });
  const googleCalendarIntegration = useQuery(api.integrations.getByProvider, {
    provider: "google_calendar",
  });
  const googleDocsIntegration = useQuery(api.integrations.getByProvider, {
    provider: "google_docs",
  });
  const googleDriveIntegration = useQuery(api.integrations.getByProvider, {
    provider: "google_drive",
  });
  const googleSheetsIntegration = useQuery(api.integrations.getByProvider, {
    provider: "google_sheets",
  });
  const googleSlidesIntegration = useQuery(api.integrations.getByProvider, {
    provider: "google_slides",
  });
  const integrations = useQuery(api.integrations.listForUser);
  const linkedinIntegration = useQuery(api.integrations.getByProvider, {
    provider: "linkedin",
  });
  const notionIntegration = useQuery(api.integrations.getByProvider, {
    provider: "notion",
  });
  const redditIntegration = useQuery(api.integrations.getByProvider, {
    provider: "reddit",
  });
  const shopifyIntegration = useQuery(api.integrations.getByProvider, {
    provider: "shopify",
  });
  const startComposioOAuthMutation = useMutation(
    api.integrations.startComposioOAuth,
  );
  const startGoogleSheetsOAuthMutation = useMutation(api.integrations.startGoogleSheetsOAuth);
  const telegramIntegration = useQuery(api.integrations.getByProvider, {
    provider: "telegram",
  });
  const telegramUsers = useQuery(api.integrations.listTelegramUsers);

  const startComposioOAuth = useCallback(
    ({ provider }: { provider: "gmail" | "google_calendar" | "google_docs" | "google_drive" | "google_slides" | "linkedin" | "notion" | "reddit" | "shopify" | "calendly" | "facebook" }) =>
      startComposioOAuthMutation({ provider, returnUrl: window.location.origin }),
    [startComposioOAuthMutation],
  );

  const startGoogleSheetsOAuth = useCallback(
    () => startGoogleSheetsOAuthMutation({ returnUrl: window.location.origin }),
    [startGoogleSheetsOAuthMutation],
  );

  return {
    calendlyIntegration,
    connectTelegram,
    disconnectComposioIntegration,
    disconnectGoogleSheets,
    disconnectTelegram,
    facebookIntegration,
    gmailIntegration,
    googleCalendarIntegration,
    googleDocsIntegration,
    googleDriveIntegration,
    googleSheetsIntegration,
    googleSlidesIntegration,
    integrations,
    linkedinIntegration,
    notionIntegration,
    redditIntegration,
    shopifyIntegration,
    startComposioOAuth,
    startGoogleSheetsOAuth,
    telegramIntegration,
    telegramUsers,
  };
}
